export interface AccessController {
	id: string
	serialNumber: string
	ipAddress: string
	port: number
	propertyId: number
	propertyShortName: string
	propertyName: string
	active: boolean
	status: AccessControllerStatus
	makeMissingDoors?: boolean // only used in create/update requests
}

export interface AccessControllerStatus {
	online: boolean
	lastSeen: string
	pendingChanges: number
	lastUpdateStartDate: string
	lastUpdateEndDate: string
	updateInProgress: boolean
}

export interface Door {
	id: string
	accessControllerId: string
	accessControllerSerialNumber: string
	doorNumber: number
	name: string
	propertyId: number
	propertyShortName: string
	propertyName: string
	fullName?: string // propertyShortName + name
	access: Access
}

export enum Access {
	UNLOCKED = "UNLOCKED",
	MANAGED = "MANAGED",
	LOCKED = "LOCKED",
}

export interface Pass {
	id: string
	name: string
	type: PassType
	propertyId?: number // not used for ROLE type
	propertyShortName?: string // not used for ROLE type
	propertyName?: string // not used for ROLE type
	unitId?: number // only for UNIT type
	unitName?: string // only for UNIT type
	doors: PassDoor[]
}

export enum PassType {
	EXTERIOR = "EXTERIOR",
	AMENITIES = "AMENITIES",
	UNIT = "UNIT",
	ROLE = "ROLE",
}

export interface PassDoor {
	doorId: string
	doorName?: string
	doorFullName?: string
	startDate?: string // yyyy-mm-ddThh:mm:ss local time
	endDate?: string // yyyy-mm-ddThh:mm:ss local time
	dailyStartTime: string // hh:mm
	dailyEndTime: string // hh:mm
}

export interface Role {
	id: string
	name: string
	passes: RolePass[]
}

export interface RolePass {
	passId: string
	passName: string
	startDate: string // yyyy-mm-ddThh:mm:ss local time
	endDate: string // yyyy-mm-ddThh:mm:ss local time
}

export interface Entity {
	id: string
	name: string
	type: EntityType
	keycards: string[]
	roleIds?: string[]
	passes?: EntityPass[]
}

export enum EntityType {
	EMPLOYEE = "EMPLOYEE",
	VENDOR = "VENDOR",
	STATIC = "STATIC",
	TEMP = "TEMP",
}

export interface EntityPass {
	passId: string
	passName: string
	startDate: string // yyyy-mm-ddThh:mm:ss local time
	endDate: string // yyyy-mm-ddThh:mm:ss local time
}

export interface KeycardDoor {
	id: string
	tenantId?: number
	entityId?: string
	entityName: string
	keycard: string
	accessControllerId: string
	accessControllerSerialNumber: string
	doorId: string
	doorNumber: number
	doorName: string
	startDate: string // yyyy-mm-ddThh:mm:ss local time
	endDate: string // yyyy-mm-ddThh:mm:ss local time
	dailyStartTime: string // hh:mm
	dailyEndTime: string // hh:mm
}

export interface SwipeRecord {
	id: string
	date: string // yyyy-mm-ddThh:mm:ss local time
	type: "SWIPE" | "REMOTE"
	status: "APPROVED" | "DENIED"
	tenantId?: number
	entityId?: string
	entityName: string
	keycard: string
	accessControllerId: string
	accessControllerSerialNumber: string
	doorId: string
	doorNumber: number
	doorName: string
}

export interface Tenant {
	TenantID: number
	Name: string
	PropertyID: number
	Property: RentManagerProperty
	UserDefinedValues: {
		UserDefinedFieldID: number
		Name: string
		Value: string
	}[]
	Leases: {
		Unit: {
			UnitID: number
			PropertyID: number
			Name: string
		}
		MoveInDate?: string // yyyy-mm-ddT00:00:00 local time
		MoveOutDate?: string // yyyy-mm-ddT00:00:00 local time
	}[]
}

export interface RentManagerProperty {
	PropertyID: number
	ShortName: string
	Name: string
}

export interface RentManagerUnit {
	UnitID: number
	PropertyID: number
	Name: string
}

export enum Group {
	AccessControl = "AccessControl",
	AccessControlRemoteAccess = "AccessControlRemoteAccess",
	AccessControlManager = "AccessControlManager",
	AccessControlAdmin = "AccessControlAdmin",
	AccessControlLocal = "AccessControlLocal",
	GlobalAdmin = "GlobalAdmin",
}
